import React from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import {
  MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR,
  MONITORING_ALARM_EXPRESSION_METRIC,
  MONITORING_ALARM_EXPRESSION_UNIT,
  MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION,
  TITLE_MONITORING_ALARM_EXPRESSION_METRIC,
  TITLE_MONITORING_ALARM_EXPRESSION_UNIT,
  TITLE_MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR,
  TITLE_MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION,
  VALIDATION,
} from 'constant';
import { enumToArray, uppercase } from 'utils';

export default ({ monitoringAlarm: monitoringAlarmEdit = {} }) => {
  const { id = '' } = monitoringAlarmEdit;

  const getDefaultProps = () => {
    const { properties = {} } = monitoringAlarmEdit;
    const {
      name = '', expression = {}, alarmDelay = '', firingActions = [],
    } = properties;

    const {
      source = {},
      metric = '',
      unit = '',
      comparisonOperator = '',
      comparisonThreshold = '',
      range = '',
      rangeAggregation = '',
    } = expression;
    const { uuid: sourceUuid = '' } = source;

    return {
      name,
      sourceUuid,
      metric: uppercase(metric) || MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_CPU_UTILIZATION_AVERAGE,
      unit: unit || MONITORING_ALARM_EXPRESSION_UNIT.TOTAL,
      comparisonOperator: comparisonOperator || MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR.GREATER_THAN_THRESHOLD,
      comparisonThreshold,
      range,
      rangeAggregation: rangeAggregation || MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION.AVERAGE,
      alarmDelay,
      firingActions,
    };
  };

  const monitoringAlarm = getDefaultProps();

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: 'Name',
    },
    {
      name: 'sourceUuid',
      type: 'server',
      title: 'Server',
      returnOnlyId: true,
    },
    {
      name: 'metric',
      type: 'dropdown',
      title: 'Metric',
      values: enumToArray(MONITORING_ALARM_EXPRESSION_METRIC).map(
        (e) => ([e, TITLE_MONITORING_ALARM_EXPRESSION_METRIC[e]]),
      ),
    },
    {
      name: 'unit',
      type: 'dropdown',
      title: 'Unit',
      values: enumToArray(MONITORING_ALARM_EXPRESSION_UNIT).map(
        (e) => ([e, TITLE_MONITORING_ALARM_EXPRESSION_UNIT[e]]),
      ),
    },
    {
      name: 'comparisonOperator',
      type: 'dropdown',
      title: 'Threshold Type',
      values: enumToArray(MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR).map(
        (e) => ([e, TITLE_MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR[e]]),
      ),
    },
    {
      name: 'comparisonThreshold',
      type: 'text',
      title: 'Threshold',
    },
    {
      name: 'range',
      type: 'text',
      title: 'Range',
    },
    {
      name: 'rangeAggregation',
      type: 'dropdown',
      title: 'Range Aggregation',
      values: enumToArray(MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION).map(
        (e) => ([e, TITLE_MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION[e]]),
      ),
    },
    {
      name: 'alarmDelay',
      type: 'text',
      title: 'Alarm Delay',
    },
    {
      name: 'firingActions',
      type: 'monitor-action',
      title: 'Actions',
      returnOnlyId: true,
    },
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, min: 3 },
    { name: 'name', type: VALIDATION.STRING, max: 63 },
    { name: 'sourceUuid', type: VALIDATION.REQUIRED },
    { name: 'metric', type: VALIDATION.REQUIRED },
    { name: 'unit', type: VALIDATION.REQUIRED },
    { name: 'comparisonOperator', type: VALIDATION.REQUIRED },
    { name: 'comparisonThreshold', type: VALIDATION.REQUIRED },
    { name: 'range', type: VALIDATION.REQUIRED },
    { name: 'range', type: VALIDATION.DURATION },
    { name: 'rangeAggregation', type: VALIDATION.REQUIRED },
    { name: 'alarmDelay', type: VALIDATION.REQUIRED },
    { name: 'alarmDelay', type: VALIDATION.DURATION },
    { name: 'firingActions', type: VALIDATION.REQUIRED },
  ];

  const onSave = (values) => {
    const {
      name,
      sourceUuid: uuid,
      metric,
      unit,
      comparisonOperator,
      comparisonThreshold,
      range,
      rangeAggregation,
      alarmDelay,
      firingActions,
    } = values;

    const properties = {
      name,
      alarmDelay,
      firingActions,
      expression: {
        comparisonOperator,
        comparisonThreshold,
        metric,
        range,
        source: { uuid },
        unit,
        rangeAggregation,
      },
    };

    if (id) actions.monitoring.alarm.update({ id, properties });
    else actions.monitoring.alarm.create(properties);
  };

  return (
    <Shared.forms.Form
      fields={fields}
      fieldsValues={monitoringAlarm}
      onSubmit={onSave}
      isCancel={false}
      validations={validations}
    />
  );
};
